import Vue from "vue";
import Vuex from "vuex";
import webproduct from "./modules/webproduct";
import config from "./modules/config";
import changeOptions from "./modules/changeOptions";
import custom from "./modules/custom";
import quantityField from "./modules/quantityField";
import costCenter from "./modules/costCenter";
import packingOptions from "./modules/packingOptions";
import personalize from "./modules/personalize";
import preview2D from "./modules/preview2D";
import preview3D from "./modules/preview3D";
import urls from "./modules/urls";
import preflightPitstop from "./modules/preflightPitstop";
import imageEditor from "./modules/imageEditor";
import preflightData from "./modules/preflightData";
import customer from "./modules/customer";
import editorFiles from "./modules/editorFiles";
import myAccount from "./modules/myAccount";
import updates from "./modules/updates";
import uploads from "./modules/uploads";
import cloneDeep from "clone-deep";

export default function makeStore() {
  return new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
      webproduct: cloneDeep(webproduct),
      config: cloneDeep(config),
      changeOptions: cloneDeep(changeOptions),
      custom: cloneDeep(custom),
      quantityField: cloneDeep(quantityField),
      costCenter: cloneDeep(costCenter),
      packingOptions: cloneDeep(packingOptions),
      personalize: cloneDeep(personalize),
      preview2D: cloneDeep(preview2D),
      preview3D: cloneDeep(preview3D),
      urls: cloneDeep(urls),
      preflightPitstop: cloneDeep(preflightPitstop),
      imageEditor: imageEditor, // leave it as it it. it has it's own life cycle
      preflightData: cloneDeep(preflightData),
      customer: cloneDeep(customer),
      editorFiles: cloneDeep(editorFiles),
      myAccount: cloneDeep(myAccount),
      updates: cloneDeep(updates),
      uploads: cloneDeep(uploads)
    }
  });
}
